// export default {
//   DCM_USER_ID: `@_DCM:__i_u_`,
//   DCM_USER_TOKEN: `@_DCM:___u_a`,
//   DCM_USER_ROLE: `@DCM:_____r__b`
// }

export const DCM_USER_TOKEN = `@_DCM:___u_a`;
export const USER_TOKEN = "@_mk____dcm";
export const styleConstants = {
  color: {
    green: "#00b04c",
    blue: "#3e7bfc",
    orange: "#ffbe00",
    red: "#fc260a",
    yellow: "#ffbe00"
  }
};
export const QUESTION_LABELS = [
  { value: "LITERACY_LETTER_IDENTIFICATION", label: "Letter Identification" },
  { value: "LITERACY_ENCODING", label: "Encoding" },
  { value: "LITERACY_DECODING", label: "Decoding" },
  { value: "LITERACY_SEGMENTATION", label: "Segmentation" },
  { value: "LITERACY_RULE_BREAKERS", label: "Rule Breaks" },
  { value: "READING_LETTER_IDENTIFICATION", label: "Letter Identification" },
  { value: "READING_ENCODING", label: "Encoding" },
  { value: "READING_DECODING", label: "Decoding" },
  { value: "READING_SEGMENTATION", label: "Segmentation" },
  { value: "READING_RULE_BREAKERS", label: "Rule Breaks" }
];
